import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { SectionCard, KeyValueRow, ProgressBar } from '../ui'
import { TenantProgramPanel } from '../TenantProgramPanel'
import { formatDate } from '../../lib/support'

// List prices per tier, as shown on the old tenants table (owner-only figure).
const MONTHLY_PRICE = { enterprise: '$499', professional: '$199', starter: '$49' }

export const BillingTab = ({ view, chatCount, onChange }) => {
  const { isOwner } = useAuth()
  const m = view.model
  const facts = [
    ['Plano', m.plan],
    ['Situação da cobrança', `${view.billing.label}${m.pastDueDays != null ? ` · ${m.pastDueDays} dias` : ''}`],
    [
      'Período de teste',
      m.billing === 'trialing' && m.trialDays != null
        ? `${m.trialDays < 0 ? 'Encerrado' : `Termina em ${m.trialDays} dias`}${m.trialEndsAt ? ` · ${formatDate(m.trialEndsAt)}` : ''}`
        : '—',
    ],
    [
      'Programa',
      m.program
        ? `${m.program.name} · ${m.program.days}d restantes${m.program.shielding ? ' · sem assinatura por trás' : ''}`
        : '—',
    ],
    ...(isOwner ? [['Receita mensal', MONTHLY_PRICE[m.tier] || '—']] : []),
  ]

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,300px),1fr))] items-start gap-4">
        <SectionCard title="Plano e cobrança" bodyClassName="gap-3">
          {facts.map(([label, value]) => (
            <KeyValueRow key={label} label={label}>
              {value}
            </KeyValueRow>
          ))}
        </SectionCard>
        <SectionCard title="Uso" bodyClassName="gap-3">
          <div className="flex flex-col gap-1.5 text-[13px]">
            <div className="flex justify-between">
              <span>Armazenamento</span>
              <span>{view.storage.text}</span>
            </div>
            <ProgressBar tone={view.storage.tone} width={view.storage.width} height={8} />
          </div>
          <KeyValueRow label="Clientes">{m.clients}</KeyValueRow>
          <KeyValueRow label="Usuários da equipe">{m.users}</KeyValueRow>
          <KeyValueRow label="Conversas de suporte (30d)">{chatCount}</KeyValueRow>
        </SectionCard>
      </div>

      {/* Collaboration program management (Titanium & friends) — read-only for staff. */}
      <TenantProgramPanel tenantId={m.id} onChange={onChange} readOnly={!isOwner} />
    </div>
  )
}
